import { Component } from '@angular/core';

@Component({
  selector: 'ui-list',
  templateUrl: './list.component.html'
})
export class ListComponent {
}